<template>
  <article class="Services">
    <header-background
      :image-src="headerImageSrc"
      class="Services-Banner"
      title="Serviços"
    />

    <the-title
      id="top-title"
      class="Services-Title"
    >Nossas Áreas de Atuação</the-title>

    <p class="Services-Paragraph">
      Utilize a lista abaixo para navegar diretamente para uma das áreas que atendemos ou clique diretamente sobre os
      títulos das áreas para saber mais.
    </p>

    <!-- SUMÁRIO -->
    <ul class="Services-List">
      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Assessoria e Consultoria."
          @click="goToCollapse($event, 'assessoria-e-consultoria', 'collapse-assessoria-e-consultoria')"
        >Assessoria e Consultoria</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Administração."
          @click="goToCollapse($event, 'administracao', 'collapse-administracao')"
        >Administração</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Assistência Social."
          @click="goToCollapse($event, 'assistencia-social', 'collapse-assistencia-social')"
        >Assistência Social</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Concursos Públicos e Processos Seletivos."
          @click="goToCollapse($event, 'concursos-publicos-e-processos-seletivos', 'collapse-concursos-publicos-e-processos-seletivos')"
        >Concursos Públicos e Processos Seletivos</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Conselho Tutelar."
          @click="goToCollapse($event, 'conselho-tutelar', 'collapse-conselho-tutelar')"
        >Conselho Tutelar</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Educação."
          @click="goToCollapse($event, 'educacao', 'collapse-educacao')"
        >Educação</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Gestão de Pessoas."
          @click="goToCollapse($event, 'gestao-de-pessoas', 'collapse-gestao-de-pessoas')"
        >Gestão de Pessoas</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Gestão da Qualidade e Produtividade no Setor Público e Privado."
          @click="goToCollapse($event, 'gestao-da-qualidade-e-produtividade-no-setor-publico-e-privado', 'collapse-gestao-da-qualidade-e-produtividade-no-setor-publico-e-privado')"
        >Gestão da Qualidade e Produtividade no Setor Público e Privado</a>;
      </li>

      <li class="Services-ListItem">
        <a
          class="Services-SummaryLink"
          title="Clique para saber mais sobre nossos serviços na área de Saúde."
          @click="goToCollapse($event, 'saude', 'collapse-saude')"
        >Saúde</a>.
      </li>
    </ul>

    <!-- ASSESSORIA E CONSULTORIA -->
    <collapse-block-with-image
      id="assessoria-e-consultoria"
      ref="collapse-assessoria-e-consultoria"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="chart_line"
      image-url="/img/background-consultant.jpg"
      side="left"
      title="Assessoria e Consultoria"
    >
      <p class="Services-Paragraph">
        Prestamos assessoria e consultoria nas áreas de <b>Administração</b>, <b>Assistência Social</b>, <b>Educação
        e Saúde</b>.
      </p>

      <p class="Services-Paragraph">
        A assessoria é uma atividade de trabalho em que é oferecida a assistência profissional para o
        alcance de objetivos previamente estabelecidos. Ela ocorre por meio de intervenção técnica e/ou orientações na
        resolução de problemas, bem como na elaboração e implementação de novas técnicas e/ou instrumentos de trabalho.
      </p>

      <p class="Services-Paragraph">
        O trabalho de consultoria consiste em fazer uma análise do cenário atual, considerando os ambientes interno e
        externo. Após a análise, são destacados os pontos de melhoria, ou seja, onde é necessário investir para
        melhorar os resultados no curto, médio e longo prazo.
      </p>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-assessoria-e-consultoria')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- ADMINISTRAÇÃO -->
    <collapse-block-with-image
      id="administracao"
      ref="collapse-administracao"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="chart_pie"
      image-url="/img/background-business-people.jpg"
      side="right"
      title="Administração"
    >
      <p class="Services-Paragraph">
        Nossa atuação na área da Administração inclui:
      </p>

      <ul class="Services-List">
        <li class="Services-ListItem">Assessoria e Consultoria;</li>
        <li class="Services-ListItem">Elaboração e/ou readequação do Estatuto dos Funcionários Públicos Municipal;</li>
        <li class="Services-ListItem">Elaboração e/ou readequação do Plano de Carreira do Servidor Público.</li>
      </ul>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-administracao')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- ASSISTÊNCIA SOCIAL -->
    <collapse-block-with-image
      id="assistencia-social"
      ref="collapse-assistencia-social"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="social_assistance"
      image-url="/img/background-social-assistance.jpg"
      side="left"
      title="Assistência Social"
    >
      <p class="Services-Paragraph">
        Nossa atuação na área de Assistência Social inclui:
      </p>

      <ul class="Services-List">
        <li class="Services-ListItem">Assessoria e Consultoria;</li>

        <li class="Services-ListItem">
          Estruturação e desenvolvimento da Rede de Serviços Municipal – Unidades Públicas: CRAS, CREAS, e Instituição
          de Longa Permanência - Casa Abrigo para Crianças e Adolescentes;
        </li>

        <li class="Services-ListItem">
          Estruturação da Vigilância Socioassistencial nos Municípios: Metodologia e processo de trabalho na gestão da
          informação;
        </li>

        <li class="Services-ListItem">
          Conselhos Municipais: Estruturação e desenvolvimento de Conselho da Assistência Social – CMAS, Conselho da
          Criança e Adolescente – CMDCA, Conselho do Idoso – CMI;
        </li>

        <li class="Services-ListItem">
          Assessoria para a realização de Conferências Municipais: Realização de Conferências Municipais nos âmbitos da
          Assistência Social, Criança e Adolescente e Idosos;
        </li>

        <li class="Services-ListItem">Estruturação e desenvolvimento do trabalho para Conselheiros Tutelares;</li>

        <li class="Services-ListItem">Trabalho com Medidas Socioeducativas em meio aberto;</li>

        <li class="Services-ListItem">Trabalho social com público do Programa Criança Feliz - PCF;</li>

        <li class="Services-ListItem">
          Palestras temáticas no âmbito da Assistência Social com temas variados de acordo com a necessidade
          apresentada pelos municípios.
        </li>
      </ul>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-assistencia-social')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- CONCURSOS PÚBLICOS E PROCESSOS SELETIVOS -->
    <collapse-block-with-image
      id="concursos-publicos-e-processos-seletivos"
      ref="collapse-concursos-publicos-e-processos-seletivos"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="exam"
      image-url="/img/background-selection-process.jpg"
      side="right"
      title="Concursos Públicos e Processos Seletivos"
    >
      <p class="Services-Paragraph">
        Realização de Concursos Públicos e Processos Seletivos Simplificados, para diversas Áreas e Níveis de
        Escolaridade.
      </p>

      <p class="Services-Paragraph">
        Realizamos todas as Fases, desde as Provas Objetivas, Práticas, Teste de Aptidão Física e Avaliação
        Psicológica.
      </p>

      <p class="Services-Paragraph">
        Elaboramos todo processo de acordo com a legislação em vigência, desde a abertura do certame até entrega de
        relatório final &dash; <i>dossiê</i> &dash; para arquivo e verificação do Tribunal de Contas.
      </p>

      <p class="Services-Paragraph">
        A Equipe é composta por profissionais, graduados, especialistas, mestres e doutores em todas as áreas do
        conhecimento, com experiência comprovada em processos de seleção.
      </p>

      <p class="Services-Paragraph">
        Todo o processo é realizado com rigoroso sigilo e segurança. No dia da aplicação todos os materiais utilizados
        no certame, são transportados em malotes com lacres de segurança.
      </p>

      <p class="Services-Paragraph">A equipe de aplicação é devidamente treinada.</p>

      <p class="Services-Paragraph">
        Os locais de aplicação recebem toda preparação necessária e são utilizados todos os meios para garantir a
        segurança do certame tais como detectores de metal, envelopes de segurança, vistoria das instalações e demais
        meios que se fizerem necessários.
      </p>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-concursos-publicos-e-processos-seletivos')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- CONSELHO TUTELAR -->
    <collapse-block-with-image
      id="conselho-tutelar"
      ref="collapse-conselho-tutelar"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="handshake"
      image-url="/img/background-tutelary-council.jpg"
      side="left"
      title="Conselho Tutelar"
    >
      <p class="Services-Subtitle">
        Processo Seletivo para Escolha dos Conselheiros Tutelares
      </p>

      <p class="Services-Paragraph">
        Todo o Processo é realizado em consonância com a COMISSÃO ESPECIAL ELEITORAL, o Edital é elaborado nos termos
        da Lei Federal Nº 8.069/90 - Estatuto da Criança e do Adolescente, da Resolução Nº 170/2014 do Conselho
        Nacional dos Direitos da Criança e do Adolescente – CONANDA, da Lei Municipal e demais Leis, princípios, normas
        e condições necessários para construção do mesmo.
      </p>

      <p class="Services-Paragraph">
        Realizamos Provas Objetivas e Dissertativas, Avaliação Psicológica e Treinamento para os Conselheiros Tutelares
        eleitos.
      </p>

      <p class="Services-Paragraph">
        Orientamos e Auxiliamos o Pleito Eleitoral, desde a disponibilização de modelos de documentos, organização das
        eleições, e acompanhamento presencial de um técnico no dia das eleições.
      </p>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-conselho-tutelar')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- EDUCAÇÃO -->
    <collapse-block-with-image
      id="educacao"
      ref="collapse-educacao"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="graduation"
      image-url="/img/background-education.jpg"
      side="right"
      title="Educação"
    >
      <p class="Services-Paragraph">
        Nossa atuação na área de Educação inclui:
      </p>

      <ul class="Services-List">
        <li class="Services-ListItem">Assessoria e Consultoria;</li>

        <li class="Services-ListItem">Elaboração e/ou readequação do Plano de Carreira do Magistério;</li>

        <li class="Services-ListItem">Avaliação do Processo de Ensino e Aprendizagem da Educação Infantil.</li>
      </ul>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-educacao')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- GESTÃO DE PESSOAS -->
    <collapse-block-with-image
      id="gestao-de-pessoas"
      ref="collapse-gestao-de-pessoas"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="users"
      image-url="/img/background-people-management.jpg"
      side="left"
      title="Gestão de Pessoas"
    >
      <p class="Services-Paragraph">
        Nossa atuação na área de Gestão de Pessoas inclui:
      </p>

      <ul class="Services-List">
        <li class="Services-ListItem">Recrutamento e Seleção;</li>

        <li class="Services-ListItem">Análise e Descrição de Cargos;</li>

        <li class="Services-ListItem">T&D - Treinamento e Desenvolvimento;</li>

        <li class="Services-ListItem">Diagnóstico de Clima Organizacional;</li>

        <li class="Services-ListItem">Trabalho e Qualidade de Vida.</li>
      </ul>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-gestao-de-pessoas')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- GESTÃO DA QUALIDADE E PRODUTIVIDADE NO SETOR PÚBLICO E PRIVADO -->
    <collapse-block-with-image
      id="gestao-da-qualidade-e-produtividade-no-setor-publico-e-privado"
      ref="collapse-gestao-da-qualidade-e-produtividade-no-setor-publico-e-privado"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="institution"
      image-url="/img/background-management-quality.jpg"
      side="right"
      title="Gestão da Qualidade e Produtividade no Setor Público e Privado"
    >
      <p class="Services-Paragraph">
        Nossa atuação na área de Gestão da Qualidade e Produtividade no Setor Público e Privado inclui:
      </p>

      <ul class="Services-List">
        <li class="Services-ListItem">
          Implantação das Diretrizes Organizacionais: Missão, Visão, Valores e Objetivos Estratégicos;
        </li>

        <li class="Services-ListItem">
          Desdobramento dos Objetivos estratégicos em Objetivos e metas departamentais: OKRs (<i>Objectives and Key
          Results</i> ou Objetivos e Resultados-Chave);
        </li>

        <li class="Services-ListItem">Levantamento, identificação e mapeamento de processos;</li>

        <li class="Services-ListItem">
          Implantação das Ferramentas da Qualidade nos processos organizacionais;
        </li>

        <li class="Services-ListItem">
          Implantação das práticas de gestão para certificações, selos e prêmios da Qualidade;
        </li>

        <li class="Services-ListItem">Preparação da organização para Certificações e Acreditação;</li>

        <li class="Services-ListItem">Formação de Multiplicadores, facilitadores e gestores da Qualidade;</li>

        <li class="Services-ListItem">
          Formação e implantação dos Comitês Gestores e Auditorias Internas para as ISOs e SGI (Sistema de Gestão
          Integrada);
        </li>

        <li class="Services-ListItem">Implantação do Gerenciamento e tratamento de não-conformidades;</li>

        <li class="Services-ListItem">
          Formação dos sucessores para as lideranças de 1º Nível (Governança Corporativa);
        </li>

        <li class="Services-ListItem">
          Implantação das práticas de Governança Corporativa e ESG (<i>Environmental, Social and Governance</i>
          &dash; Ambiental, Social e Governança);
        </li>

        <li class="Services-ListItem">
          Implantação de Indicadores estratégicos para gestão, monitoramento e avaliação da Qualidade de Serviços.
        </li>
      </ul>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-gestao-da-qualidade-e-produtividade-no-setor-publico-e-privado')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <!-- SAÚDE -->
    <collapse-block-with-image
      id="saude"
      ref="collapse-saude"
      :start-expanded="false"
      class="Services-Collapsable"
      icon="heart"
      image-url="/img/background-health.jpg"
      side="left"
      title="Saúde"
    >
      <p class="Services-Paragraph">
        Nossa atuação na área de Saúde inclui:
      </p>

      <ul class="Services-List">
        <li class="Services-ListItem">Assessoria e Consultoria;</li>

        <li class="Services-ListItem">Realização do diagnóstico situacional de equipes;</li>

        <li class="Services-ListItem">
          Elaboração do Planejamento Estratégico para Reestruturação do atendimento na Saúde;
        </li>

        <li class="Services-ListItem">Implantação de Programa de Melhoria de Processos;</li>

        <li class="Services-ListItem">
          Elaboração e implantação de Programa permanente de atualização e reciclagem de perfil profissional;
        </li>

        <li class="Services-ListItem">
          Implantação de fluxos, processos, procedimentos e registros aplicáveis em todos os níveis e adequação da
          infraestrutura local.
        </li>
      </ul>

      <p class="Services-Paragraph Services-Paragraph--center">
        <a
          class="Services-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-saude')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .Services {
    width: 100%;

    &-Banner {
      margin-bottom: 10px;
    }

    &-Title {
      margin: 15px 20px;
    }

    &-Collapsable {
      margin: 15px 30px;
    }

    &-Subtitle {
      margin: 15px 20px;
      font-size: 18px;
      font-weight: 800;
      padding-left: 10px;
    }

    &-Paragraph {
      margin: 15px 30px;
      text-align: justify;

      &--center {
        text-align: center;
      }
    }

    &-List {
      margin: 10px 30px;
      font-weight: 400;
    }

    &-ListItem {
      font-weight: 400;
      margin: 5px 0;
      text-align: justify;

      &--hasChildren {
        font-weight: bold;
      }
    }
  }
</style>

<script>
  import { CollapseMixin } from "@/common/mixins";
  import HeaderBackground from "@/components/HeaderBackground";
  import TheTitle from "@/components/TheTitle";
  import CollapseBlockWithImage from '@/components/CollapseBlockWithImage.vue';

  export default {
    name: "Services",

    components: {
      HeaderBackground,
      TheTitle,
      CollapseBlockWithImage,
    },

    mixins: [CollapseMixin],

    data() {
      return {
        headerImageSrc: "/img/backgrounds/csc-02.jpg",
      };
    },
  };
</script>
